/* globals gtag */

import React, { useMemo, useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  SetSearchWord,
  SetActiveFilters,
  SetProducts,
  SetResultsCount,
  SetAutocompleteOptions,
  SetAutocompleteCategoriesOptions,
  SetConfig,
  SetMasterCategories,
  SetPage,
  SetPrevProducts,
  SetIsAutocompleteOpen,
  SetIsFromHalfScreen,
} from "../../state/actions/index"
import "./Header.css"
import Utils from "../../utils/Utils"

const Header = () => {
  const searchWord = useSelector((state) => state.searchWord)
  const isFromHalfScreen = useSelector((state) => state.isFromHalfScreen)
  const config = useSelector((state) => state.config)
  const resultsCount = useSelector((state) => state.resultsCount)
  const products = useSelector((state) => state.config.placeholders.products)
  const isMobile = useSelector((state) => state.isMobile)
  const activeFilters = useSelector((state) => state.activeFilters)
  const alertConfig = useSelector((state) => state.config.alert)
  const shopId = useSelector((state) => state.config.shopId)
  const baseUrl = useSelector((state) => state.config.baseUrl)
  const display = useSelector((state) => state.config.display)
  const accentColor = useSelector((state) => state.config.accentColor)
  const autocomplete = useSelector((state) => state.config.autocomplete)
  const triggers = useSelector((state) => state.config.triggers)
  const ga4 = useSelector((state) => state.config.ga4)
  const show = useSelector((state) => state.config.show)
  // const isSearching = useSelector(state => state.isSearching);
  const defaultMasterCategories = useSelector(
    (state) => state.defaultMasterCategories
  )
  var minChars = useMemo(
    () =>
      isMobile ? autocomplete.minChars.mobile : autocomplete.minChars.desktop,
    [isMobile, autocomplete]
  )
  var isSearchwordShort = useMemo(
    () => searchWord.length < minChars,
    [searchWord, minChars]
  )
  const dispatch = useDispatch()

  var isAlertActive = useMemo(
    () =>
      (isMobile && alertConfig.mobile) || (!isMobile && alertConfig.desktop),
    [isMobile, alertConfig]
  )

  const backClick = useCallback(() => {
    dispatch(SetSearchWord(""))
    if (show.type === "input" && !isMobile)
      Utils.closeLayer(display, window.innerWidth <= 768)
    dispatch(SetAutocompleteCategoriesOptions([]))
    dispatch(SetAutocompleteOptions([]))
    dispatch(SetIsAutocompleteOpen(false))
    dispatch(SetActiveFilters([]))
    dispatch(SetProducts([]))
    dispatch(SetPrevProducts([]))
    dispatch(SetResultsCount(0))
    dispatch(SetPage(1))
    dispatch(SetMasterCategories(defaultMasterCategories))
  }, [dispatch, defaultMasterCategories, show, display, isMobile])

  const closeClick = useCallback(() => {
    Utils.sendAnalyticsObject(baseUrl, shopId, "as_close")
    const customEvent = new CustomEvent("as-close-layer")
    document.body.dispatchEvent(customEvent)
    if (!!ga4?.isActive) {
      if (typeof window.dataLayer !== "undefined" && !!window.dataLayer) {
        window.dataLayer.push({
          event: "as_close",
          data: {},
        })
      } else if (typeof gtag !== "undefined") {
        gtag("event", "as_close", {})
      }
    }
    sessionStorage.setItem("isLayerOpen", "false")
    Utils.closeLayer(display, isMobile)
    if (isFromHalfScreen) {
      dispatch(SetIsFromHalfScreen(false))
      config.display = "half-screen"
      dispatch(SetConfig(config))
    }
  }, [display, isMobile, shopId, baseUrl, isFromHalfScreen, config, dispatch])
  return (
    <div
      className={
        "header " +
        (activeFilters.length > 0 || !isSearchwordShort
          ? "with-products"
          : "") +
        (isAlertActive ? " with-alert" : "")
      }
    >
      {triggers.logo !== "" ? (
        <img className="logo" src={triggers.logo} alt="logo-header"></img>
      ) : null}
      {searchWord !== "" || activeFilters.length > 0 ? (
        <div className="left icon close" onClick={backClick}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 0 24 24"
            width="24"
          >
            <path d="M0 0h24v24H0z" fill="none" />
            <path
              d="M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z"
              style={{ fill: accentColor }}
            />
          </svg>
        </div>
      ) : null}
      <div className="icon close" onClick={closeClick}></div>
      {isMobile &&
      (searchWord !== "" || activeFilters.length > 0) /* && !isSearching */ ? (
        <div className="results-count"> {resultsCount + " " + products} </div>
      ) : null}
    </div>
  )
}

export default Header
